import React, { useState, useEffect, useMemo } from "react";
import CustomDatatableGrid from "../../components/CustomDatatableGrid";
import { customTableStyles } from "../../assets/CustomTableStyles";
import { get, post } from "../../services/api";
import { toast } from "react-toastify";
import Select from "react-select";
import { useForm, Controller } from "react-hook-form";
import WithdrawalInterviewModal from "./WithdrawalInterviewModal";
import PayWithdrawalChallanModal from "./PayWithdrawalChallanModal";
import IssuedItemsModal from "./IssuedItemsModal";
import IISSLogo from "../../assets/img/logo-full.png";
import BookModal from "../lms/BookModal";
import * as XLSX from "xlsx";
import jsPDF from "jspdf";
import "jspdf-autotable";
import FullScreenLoader from "../../components/FullScreenLoader";
import WithdrawalConfirmationModal from "./WithdrawalConfirmationModal";
import CancelWithdrawalModal from "./CancelWithdrawalModal";
import ExitInterviewRemarksModal from "./ExitInterviewRemarksModal";
import PaymentProofModal from "../../components/modals/PaymentProofModal";
import AskConfirmationModal from "../../components/modals/AskConfirmationModal";
import NotificationEventTypes from "../../constants/notificationEventsEnum";
import StudentProfile from "../student/student_profile/StudentProfile";
import ReAdmissionModal from "./ReAdmissionModal";

function WithdrawalProcess() {
  const token = localStorage.getItem("token");
  const savedCenterId =
    localStorage.getItem("centerId") === "null"
      ? null
      : localStorage.getItem("centerId");
  const organizationId = localStorage.getItem("organizationId");

  const [withdrawalData, setWithdrawalData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [loading, setLoading] = useState(false);
  const [triggerRerender, setTriggerRender] = useState(false);
  const [centersData, setCentersData] = useState([]);
  const [centersId, setCenterId] = useState(null);
  const [isInterviewModalVisible, setIsInterviewModalVisible] = useState(false);
  const [isRemarksModalVisible, setIsRemarksModalVisible] = useState(false);
  const [showCancelModal, setShowCancelModal] = useState(false);
  const [selectedWithdrawalId, setSelectedWithdrawalId] = useState(null);
  const [
    isWithdrawalConfirmationModalVisible,
    setIsWithdrawalConfirmationModalVisible,
  ] = useState(false);
  const [selectedStudentId, setSelectedStudentId] = useState(null);
  const [selectedStudentWithdrawalId, setSelectedStudentWithdrawalId] =
    useState(null);
  const [selectedInterviewData, setSelectedInterviewData] = useState(null);
  const [isPayChallanModalVisible, setIsPayChallanModalVisible] =
    useState(false);
  const [isCancelWithdrawalModalVisible, setCancelWithdrawalModalVisible] =
    useState(false);
  const [isIssuedItemsModalVisible, setIsIssuedItemsModalVisible] =
    useState(false);
  const [modalData, setModalData] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [selectedWithdrawalData, setSelectedWithdrawalData] = useState(null);
  const [issuedItemsData, setIssuedItemsData] = useState(null);
  const [currentDepartment, setCurrentDepartment] = useState(null);
  const roleId = localStorage.getItem("roleId");
  const userId = localStorage.getItem("userId");
  const [searchTerm, setSearchTerm] = useState("");
  const [departments, setDepartments] = useState([]);
  const departmentId = localStorage.getItem("departmentId");
  const [isPaymentProofModalVisible, setIsPaymentProofModalVisible] =
    useState(false);
  const [paymentProofModalData, setPaymentProofModalData] = useState(null);
  const [isVerifyPaymentModalOpen, setIsVerifyPaymentModalOpen] =
    useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [selectedStudent, setSelectedStudent] = useState(null);
  const [isProfileModalOpen, setIsProfileModalOpen] = useState(false);
  const [uploadedProofs, setUploadedProofs] = useState({});
  const [studentsData, setStudentsData] = useState([]);
  const [isReAdmissionModalVisible, setIsReAdmissionModalVisible] =
    useState(false);
  const [selectedStudentForReAdmission, setSelectedStudentForReAdmission] =
    useState(null);
  const placeholderLogo =
    "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAABkCAIAAAD/gAIDAAAACXBIWXMAAAsTAAALEwEAmpwYAAABJklEQVR4nO3TsQ3AMAwAwfxf6WADYgMLcQAFa4AJa4AJ0zM+7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozv7DwAALB0i1O1VHrUAAAAASUVORK5CYII=";

  const fetchDepartments = async () => {
    try {
      const response = await get(
        `CommonSettings/GetCommonSettingDetailByModuleName?moduleName=Department`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      setDepartments(response?.commonSettingDetail || []);
    } catch (error) {
      console.error(`Error fetching departments:`, error);
    }
  };

  useEffect(() => {
    fetchDepartments();
  }, []);

  const { control, setValue } = useForm();

  const handleExitInterview = (studentId) => {
    const student = withdrawalData.find((s) => s.id === studentId);
    setSelectedStudentId(studentId);
    setSelectedInterviewData(student || {});
    setIsInterviewModalVisible(true);
  };

  const handleInterviewRemarks = (studentId) => {
    const student = withdrawalData.find((s) => s.id === studentId);
    setSelectedStudentId(studentId);
    setSelectedInterviewData(student || {});
    setIsRemarksModalVisible(true);
  };

  const fetchStudents = async (studentId) => {
    try {
      const response = await get(
        `Student/GetStudentByIdAsync?studentId=${studentId}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      return response;
    } catch (error) {
      console.error("Error fetching students:", error);
      toast.error(`Failed to fetch student data: ${error.message}`);
      return null;
    }
  };

  const handlePayChallan = async (studentFirstRegistrationId) => {
    try {
      const response = await get(
        `Withdrawal/GetWithdrawalVoucherByRegIdAsync?studentFirstRegistrationId=${studentFirstRegistrationId}`,
        { headers: { Authorization: `Bearer ${token}` } }
      );
      if (response.isSuccess && response.registrationVoucher) {
        setSelectedWithdrawalData(response.registrationVoucher[0]);
        setIsPayChallanModalVisible(true);
      } else {
        toast.error("Error fetching withdrawal voucher.");
      }
    } catch (error) {
      console.error("Error fetching withdrawal voucher:", error);
      toast.error("An error occurred while fetching the withdrawal voucher.");
    }
  };

  const handleWithdrawalConfirmation = (row) => {
    setSelectedStudentId(row.studentId);
    setSelectedStudentWithdrawalId(row.id);
    setIsWithdrawalConfirmationModalVisible(true);
  };

  const handleIssuedItemsButtonClick = async (studentId, departmentName) => {
    try {
      let response;
      if (departmentName === "Activity") {
        response = await get(
          `CampusActivity/GetAllActivityStudentId?studentId=${studentId}`,
          { headers: { Authorization: `Bearer ${token}` } }
        );
        if (response.isSuccess) {
          const mappedData = {
            departmentName: "Activity",
            studentId: studentId,
            studentName:
              response.invoiceReturnResponseList[0]?.pupileName || "Unknown",
            deparmentIssueDatas: response.invoiceReturnResponseList.map(
              (item) => ({
                items: item.activityName,
                issuedDate: item.slotStartTime,
              })
            ),
          };
          setIssuedItemsData(mappedData);
          setCurrentDepartment(departmentName);
          setIsIssuedItemsModalVisible(true);
        } else {
          toast.error("Error fetching activity data.");
        }
      } else {
        response = await get(
          `Withdrawal/GetDepartmentIssuedData?departmentName=${departmentName}&studentId=${studentId}`,
          { headers: { Authorization: `Bearer ${token}` } }
        );
        if (response.isSuccess) {
          setIssuedItemsData(response.departmentIssuedData);
          setCurrentDepartment(departmentName);
          setIsIssuedItemsModalVisible(true);
        } else {
          toast.error("Error fetching issued items data.");
        }
      }
    } catch (error) {
      console.error("Error fetching issued items data:", error);
      toast.error("An error occurred while fetching issued items data.");
    }
  };

  const handleCancelWithdrawal = async (withdrawalId, reason) => {
    try {
      const response = await post(
        `Withdrawal/Cancel?withdrawalId=${withdrawalId}&reason=${encodeURIComponent(
          reason
        )}`,
        {},
        { headers: { Authorization: `Bearer ${token}` } }
      );
      if (response.isSuccess) {
        toast.success(response.message);
        getWithdrawalProcessList();
      } else {
        toast.error("Error canceling withdrawal.");
      }
    } catch (error) {
      console.error("Error canceling withdrawal:", error);
      toast.error("An error occurred while canceling withdrawal.");
    }
  };

  const handleOpenCancelModal = (withdrawalId) => {
    setSelectedWithdrawalId(withdrawalId);
    setShowCancelModal(true);
  };

  const submitApproveClick = async (formData) => {
    if (!token) {
      console.error("Unauthorized.");
      return;
    }

    const currentDate = new Date().toISOString().split("T")[0];

    const formDataWithPaymentInfo = {
      isStatus: true,
      approvalDate: currentDate,
      id: formData.id,
      amount: formData.amount,
      departmentName: formData.departmentName,
      remarks: formData.remarks,
    };

    try {
      const response = await post(
        "Withdrawal/UpdateWithdrawalStatusDepartmentwiseById",
        formDataWithPaymentInfo,
        { headers: { Authorization: `Bearer ${token}` } }
      );
      if (response.isSuccess) {
        toast.success(response.message || "Success!");
        setIsIssuedItemsModalVisible(false);
        setWithdrawalData((prevData) =>
          prevData.map((student) => {
            if (student.id === formData.id) {
              const deptId = departments.find(
                (dept) => dept.value === formData.departmentName
              )?.id;
              if (deptId) {
                return {
                  ...student,
                  departments: {
                    ...student.departments,
                    [deptId]: {
                      ...student.departments[deptId],
                      approved: true,
                      amount: formData.amount,
                    },
                  },
                };
              }
            }
            return student;
          })
        );
        getWithdrawalProcessList();
      } else {
        toast.error("Failed to process payment.");
      }
    } catch (error) {
      console.error("Error processing payment:", error);
      toast.error("An error occurred while processing the payment.");
    }
  };

  const handleUploadPaymentProofClick = async (row) => {
    setPaymentProofModalData(row);
    setIsPaymentProofModalVisible(true);
  };

  const submitPaymentProof = async (formData) => {
    if (!token) {
      console.error("Unauthorized.");
      return;
    }

    const formDataWithAdditionalInfo = {
      ...formData,
      FormId: 59,
      NotificationEventTypeIds: NotificationEventTypes.APPROVE.toString(),
    };

    try {
      const response = await post(
        `Withdrawal/AddWithdrawalInvoiceReceipt`,
        formDataWithAdditionalInfo,
        { headers: { Authorization: `Bearer ${token}` } }
      );
      if (response.isSuccess) {
        toast.success(
          response.message || "Payment proof uploaded successfully!"
        );
        setUploadedProofs((prev) => ({
          ...prev,
          [formData.id]: true,
        }));
        setIsPaymentProofModalVisible(false);
        setTriggerRender((prev) => !prev);
      } else {
        toast.error("Failed to upload payment proof.");
      }
    } catch (error) {
      console.error("Error uploading payment proof:", error);
      toast.error("An error occurred while uploading payment proof.");
    }
  };

  const handleVerifyPaymentProofClick = (withdrawalId) => {
    setSelectedWithdrawalId(withdrawalId);
    setIsVerifyPaymentModalOpen(true);
  };

  const handleVerifyPaymentConfirm = async () => {
    setIsSubmitting(true);
    try {
      const response = await post(
        `Withdrawal/VerifyWithdrawalVoucherChallan?id=${selectedWithdrawalId}`,
        {},
        { headers: { Authorization: `Bearer ${token}` } }
      );

      if (response.isSuccess) {
        toast.success(
          response.message || "Payment proof verified successfully!"
        );
        setTriggerRender((prev) => !prev);
      } else {
        toast.error("Failed to verify payment proof.");
      }
    } catch (error) {
      console.error("Error verifying payment proof:", error);
      toast.error("An error occurred while verifying payment proof.");
    } finally {
      setIsVerifyPaymentModalOpen(false);
      setSelectedWithdrawalId(null);
      setIsSubmitting(false);
    }
  };

  const submitPayWithdrawalChallan = async (formData) => {
    if (!token) {
      console.error("Unauthorized.");
      return;
    }

    const currentDate = new Date();
    const dateString = currentDate.toISOString();

    const formDataWithPaymentInfo = {
      ...formData,
      createdBy: localStorage.getItem("userId"),
      updatedBy: localStorage.getItem("userId"),
      paidBy: localStorage.getItem("userId"),
      isPaid: true,
      paymentDate: dateString,
      id: formData.id,
      voucherNo: formData.voucherNo,
      FormId: 59,
      NotificationEventTypeIds: NotificationEventTypes.FORWARD.toString(),
    };

    try {
      const response = await post(
        "withdrawal/UpdateWithdrawalVoucherPaidAsync",
        formDataWithPaymentInfo,
        { headers: { Authorization: `Bearer ${token}` } }
      );
      if (response.isSuccess) {
        toast.success(response.message || "Success!");
        setIsPayChallanModalVisible(false);
        setTriggerRender((prev) => !prev);
        getWithdrawalProcessList();
      } else {
        toast.error("Failed to process payment.");
      }
    } catch (error) {
      console.error("Error processing payment:", error);
    }
  };

  const handleReAdmission = (studentId) => {
    setSelectedStudentForReAdmission(studentId);
    setIsReAdmissionModalVisible(true);
  };

  useEffect(() => {
    const fetchCenters = async () => {
      try {
        const response = await get(
          `Dropdown/GetAllCentersByOrganizationId?organizationId=${organizationId}`,
          { headers: { Authorization: `Bearer ${token}` } }
        );
        if (response && response.length > 0) {
          setCentersData(response);
          let selectedCenter = null;
          if (
            savedCenterId &&
            savedCenterId !== "0" &&
            savedCenterId !== "null"
          ) {
            selectedCenter = response.find(
              (center) => center.id === parseInt(savedCenterId, 10)
            );
          }
          if (!selectedCenter) {
            selectedCenter = response[0];
          }
          if (selectedCenter) {
            setValue("centerId", {
              value: selectedCenter.id,
              label: selectedCenter.name,
            });
            setCenterId(selectedCenter.id);
          } else {
            console.error("No valid centers available");
            toast.error("No centers available. Please contact support.");
          }
        } else {
          console.error("No centers returned from API");
          toast.error("Failed to load centers. Please try again.");
        }
      } catch (error) {
        console.error("Error fetching centers:", error);
        toast.error("An error occurred while fetching centers.");
      }
    };

    if (token && organizationId) {
      fetchCenters();
    }
  }, [token, organizationId, setValue, savedCenterId]);

  const getWithdrawalProcessList = async () => {
    if (!token || !centersId) {
      console.error("Unauthorized or no center selected.");
      setWithdrawalData([]);
      setIsLoading(false);
      toast.error("Please select a valid center to load withdrawals.");
      return;
    }

    try {
      setIsLoading(true);
      const response = await get(
        `withdrawal/GetWithdrawalByCenterId?CenterId=${centersId}&userId=${userId}`,
        { headers: { Authorization: `Bearer ${token}` } }
      );
      if (response.isSuccess) {
        const data = response.withdrawal || [];
        const normalizedData = data.map((student) => ({
          ...student,
          departments: Object.fromEntries(
            departments.map((dept) => [
              dept.id,
              {
                approved: student[`is${dept.key}`] || false,
                amount: student[`${dept.key.toLowerCase()}Amount`] || "",
                ...student.departments?.[dept.id],
              },
            ])
          ),
        }));

        setWithdrawalData(normalizedData);
      } else {
        console.error("API returned unsuccessful response:", response.message);
        setWithdrawalData([]);
        toast.error("Failed to load withdrawal data. Please try again.");
      }
    } catch (error) {
      console.error("Error fetching withdrawal data:", error);
      setWithdrawalData([]);
      toast.error("An error occurred while fetching withdrawal data.");
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    if (centersId && departments.length) {
      getWithdrawalProcessList();
    } else {
      setWithdrawalData([]);
      setIsLoading(false);
    }
  }, [centersId, departments, triggerRerender]);

  const handleApprove = async (studentId, departmentId, deptName) => {
    const student = withdrawalData.find((s) => s.id === studentId);
    if (!student) return;

    const deptInfo = student.departments[departmentId] || {
      approved: false,
      amount: "0",
    };
    const newApprovedStatus = !deptInfo.approved;

    const requestBody = {
      id: studentId,
      isStatus: true,
      amount: deptInfo.amount || "0",
      approvalDate: new Date().toISOString(),
      departmentName: deptName,
    };
    try {
      const response = await post(
        "withdrawal/UpdateWithdrawalStatusDepartmentwiseById",
        requestBody,
        { headers: { Authorization: `Bearer ${token}` } }
      );
      if (response.isSuccess) {
        setWithdrawalData((prevData) =>
          prevData.map((s) => {
            if (s.id === studentId) {
              return {
                ...s,
                departments: {
                  ...s.departments,
                  [departmentId]: {
                    ...deptInfo,
                    approved: newApprovedStatus,
                    amount: newApprovedStatus ? deptInfo.amount : "0",
                  },
                },
              };
            }
            return s;
          })
        );
        toast.success("Approval status updated successfully.");
      } else {
        toast.error("Failed to update approval status.");
      }
    } catch (error) {
      console.error("Error updating approval status:", error);
      toast.error("An error occurred while updating approval status.");
    }
  };

  const handleAmountChange = (studentId, departmentId, value) => {
    setWithdrawalData((prevData) =>
      prevData.map((student) => {
        if (student.id === studentId) {
          const departments = student.departments || {};
          const deptInfo = departments[departmentId] || {
            approved: false,
            amount: "",
          };
          return {
            ...student,
            departments: {
              ...departments,
              [departmentId]: { ...deptInfo, amount: value },
            },
          };
        }
        return student;
      })
    );
  };

  const handleGenerateChallan = async (studentId) => {
    if (!studentId) {
      toast.error("Student ID is required");
      return;
    }

    setLoading(true);
    try {
      // Fetch student data
      const student = await fetchStudents(studentId);
      if (!student) {
        throw new Error("Student not found");
      }

      console.log("Student data:", student); // Debug log to see actual student structure

      // Use the correct field names from the student response
      const sessionId = student.centerSessionId; // This is 11 from your response
      const classId = student.centerClassId; // This is 1 from your response

      if (!sessionId || !classId) {
        throw new Error("Student session or class information is missing");
      }

      // Fetch withdrawal fee plans with correct parameters
      const feePlanResponse = await get(
        `InspRegistration/CenterFeePlansWithdrawal?centerId=${savedCenterId}&sessionId=${sessionId}&classId=${classId}&organizationId=${organizationId}&registrationId=${studentId}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (!feePlanResponse.isSuccess || !feePlanResponse.centerFeePlans) {
        throw new Error(feePlanResponse.message || "Failed to fetch fee plans");
      }

      const feeItems = feePlanResponse.centerFeePlans;

      if (!feeItems || feeItems.length === 0) {
        throw new Error("No applicable fees found for this student");
      }
      // Filter ONLY for Tuition Fee type - skip all other fee types
      const tuitionFees = feeItems.filter(
        (item) =>
          item.feeTypeName === "Tution Fee" ||
          item.feeTypeName?.toLowerCase().includes("tution Fee")
      );
      console.log(tuitionFees);
      if (tuitionFees.length === 0) {
        throw new Error("No Tuition Fee found for this student");
      }

      const feesToUse = tuitionFees;
      const withdrawal = withdrawalData.find(
        (withdrawal) => withdrawal.studentId === studentId
      );

      // Create withdrawal voucher
      const voucherPayload = {
        studentFirstRegistrationId: studentId,
        id: withdrawal.id,
        paidBy: localStorage.getItem("userId"),
        remarks: "",
        bankName: "",
        accountNo: "",
        receiptNo: "",
        registrationVoucherDetails: feesToUse.map((item) => ({
          feeTypeName: item.feeTypeName,
          amount: item.amount || item.feeAmount || 0,
        })),
      };

      const voucherResponse = await post(
        `InspRegistration/CreateWithdrawalVoucher`,
        voucherPayload,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (!voucherResponse.isSuccess || !voucherResponse.challanNo) {
        throw new Error(
          voucherResponse.message || "Failed to create withdrawal voucher"
        );
      }

      // Calculate total amount
      const totalAmount = feesToUse.reduce(
        (sum, item) => sum + (item.amount || item.feeAmount || 0),
        0
      );

      // Get student full name
      const studentFullName =
        `${student.firstName || ""} ${student.lastName || ""}`.trim() ||
        student.firstName ||
        "Unknown";

      // Prepare data for the challan
      const challanData = {
        items: feesToUse.map((item) => ({
          headName: item.feeTypeName,
          headCode: item.code,
          amount: item.amount || item.feeAmount || 0,
          periodDesc: `${item.feeCycleName || ""} (${item.feePlanName || ""})`,
          waiveOfAmount: 0,
          challanNo: voucherResponse.challanNo,
          centerName: "IISS",
          studentName: studentFullName,
          firstRegistrationId: student.id,
          className: item.className || "N/A",
          challanDate: new Date(),
          dueDate: voucherResponse.paymentDate
            ? voucherResponse.paymentDate.split("T")[0]
            : new Date(Date.now() + 7 * 24 * 60 * 60 * 1000)
                .toISOString()
                .split("T")[0],
          totalAmount: totalAmount,
          nwaAccountNo: "1234567890",
          branchCode: "0001",
          branchName: "Main Branch",
          isPaid: false,
          baseUrl: "",
        })),
      };

      // Generate PDF
      const doc = new jsPDF("landscape", "pt", "a4");

      // Define styles
      const styles = {
        font: "helvetica",
        fontSize: 9.5,
        cellPadding: 2,
        lineWidth: 0.5,
        lineColor: [0, 0, 0],
      };

      // Define copies
      const copies = ["Bank Copy", "School Copy", "Student Copy"];
      let currentX = 20;

      // Load logo image
      let logoImage = placeholderLogo; // Default to placeholder
      try {
        // If IISSLogo is a file path, load it dynamically
        const response = await fetch(IISSLogo);
        if (response.ok) {
          const blob = await response.blob();
          logoImage = await new Promise((resolve) => {
            const reader = new FileReader();
            reader.onloadend = () => resolve(reader.result);
            reader.readAsDataURL(blob);
          });
        }
      } catch (error) {
        console.warn("Failed to load IISSLogo, using placeholder:", error);
      }

      copies.forEach((copy, index) => {
        // Header (Logo and Copy Name)
        doc.addImage(logoImage, "PNG", currentX, 20, 100, 40);
        doc.setFont("helvetica", "normal");
        doc.setFontSize(8.5);
        doc.text(`${copy}`, currentX + 110, 40, { align: "left" });

        // Challan number
        doc.autoTable({
          startY: 80,
          body: [
            [
              {
                content: `Challan #: ${challanData.items[0].challanNo}`,
                styles: { halign: "center" },
              },
            ],
          ],
          styles,
          margin: { left: currentX },
          tableWidth: 260,
        });

        // School and student info
        doc.autoTable({
          startY: doc.lastAutoTable.finalY + 10,
          body: [
            [
              {
                content: `IISS: ${challanData.items[0].centerName} Campus`,
                styles: { fontStyle: "bold" },
              },
            ],
            [
              {
                content: `Student Name: ${challanData.items[0].studentName}`,
                styles: { fontStyle: "bold" },
              },
            ],
            [
              {
                content: `Class: ${challanData.items[0].className}`,
                styles: { fontStyle: "bold" },
              },
            ],
            [
              {
                content: `Issue Date: ${challanData.items[0].challanDate.toLocaleDateString(
                  "en-GB",
                  {
                    day: "2-digit",
                    month: "2-digit",
                    year: "numeric",
                  }
                )}`,
                styles: { fontStyle: "bold" },
              },
            ],
            [
              {
                content: `Due Date: ${challanData.items[0].dueDate}`,
                styles: { fontStyle: "bold" },
              },
            ],
            [
              {
                content: "WITHDRAWAL FEE CHALLAN - TUITION FEE ONLY",
                styles: { halign: "center", fontStyle: "bold", fontSize: 11.5 },
              },
            ],
          ],
          styles: { ...styles, border: 0 },
          margin: { left: currentX },
          tableWidth: 260,
        });

        // Fee items table
        doc.autoTable({
          startY: doc.lastAutoTable.finalY + 10,
          head: [["Description", "Amount"]],
          body: challanData.items.map((item) => [
            item.headName,
            { content: `${item.amount}`, styles: { halign: "right" } },
          ]),
          styles,
          headStyles: {
            fillColor: [255, 255, 255],
            textColor: [0, 0, 0],
            fontStyle: "bold",
          },
          margin: { left: currentX },
          tableWidth: 260,
        });

        // Total table
        doc.autoTable({
          startY: doc.lastAutoTable.finalY + 5,
          body: [
            [
              { content: "Total", styles: { fontStyle: "bold" } },
              {
                content: `${challanData.items[0].totalAmount}`,
                styles: { halign: "right", fontStyle: "bold" },
              },
            ],
            [
              { content: "Paid / Adjusted", styles: { fontStyle: "normal" } },
              { content: "", styles: { halign: "right" } },
            ],
            [
              {
                content: "Total Payment By Due Date",
                styles: { fontStyle: "bold" },
              },
              {
                content: `${challanData.items[0].totalAmount}`,
                styles: {
                  halign: "right",
                  fontStyle: "bold",
                },
              },
            ],
          ],
          styles: { ...styles, border: 0 },
          margin: { left: currentX },
          tableWidth: 260,
        });

        // Bank details table
        doc.autoTable({
          startY: doc.lastAutoTable.finalY + 30,
          body: [
            ["Account # Collection:", challanData.items[0].nwaAccountNo],
            ["Branch Code:", challanData.items[0].branchCode],
            ["Account Title:", `IISS ${challanData.items[0].centerName}`],
            ["Branch Name:", challanData.items[0].branchName],
            ["Challan No.:", challanData.items[0].challanNo],
            ["Due Date:", challanData.items[0].dueDate],
          ],
          styles: { ...styles, fontSize: 7.5, border: 1 },
          margin: { left: currentX },
          tableWidth: 260,
        });

        // Footer table
        doc.autoTable({
          startY: doc.lastAutoTable.finalY + 10,
          body: [
            [
              {
                content: "CASH ONLY\nBank Stamp Here",
                styles: {
                  halign: "center",
                  fontSize: 17.5,
                  fontStyle: "bold",
                  textColor: [225, 225, 225],
                },
              },
            ],
          ],
          styles: { ...styles, border: 0 },
          margin: { left: currentX },
          tableWidth: 260,
        });

        // System generated note
        doc.autoTable({
          startY: doc.lastAutoTable.finalY + 10,
          body: [
            ["This is a system-generated document and needs no signature"],
          ],
          styles: { ...styles, fontSize: 7, border: 0 },
          margin: { left: currentX },
          tableWidth: 260,
        });

        currentX += 270; // Move to next column
      });

      // Convert PDF to Blob and open in new tab
      const pdfBlob = doc.output("blob");
      const pdfUrl = URL.createObjectURL(pdfBlob);
      window.open(pdfUrl, "_blank");

      toast.success("Withdrawal challan generated successfully!");
    } catch (error) {
      console.error("Error generating challan:", error);
      toast.error(`Failed to generate withdrawal challan: ${error.message}`);
    } finally {
      setLoading(false);
    }
  };
  const exportToExcel = () => {
    const exportData = withdrawalData.map((row, index) => ({
      "Sr No": index + 1,
      "Student Name": row.studentName,
      "Roll No": row.rollNo,
      "Parent Name": row.primeryContactName,
      "Parent Contact": row.primeryContact,
      "Exit Interview": row.isInterviewScheduled ? "Done" : "Not Scheduled",
      ...departments.reduce((acc, dept) => {
        const deptInfo = row.departments?.[dept.id] || {};
        acc[`${dept.value} Approved`] = deptInfo.approved ? "Yes" : "No";
        acc[`${dept.value} Amount`] = deptInfo.amount || "0";
        return acc;
      }, {}),
    }));
    const worksheet = XLSX.utils.json_to_sheet(exportData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Withdrawal Process");
    XLSX.writeFile(workbook, "WithdrawalProcess.xlsx");
  };

  const exportToPDF = () => {
    const doc = new jsPDF();
    const pageWidth = doc.internal.pageSize.getWidth();
    const title = "Withdrawal Process List";
    doc.setFontSize(12);
    doc.setFont("helvetica", "bold");
    const textWidth = doc.getTextWidth(title);
    const titleX = (pageWidth - textWidth) / 2;
    doc.text(title, titleX, 20);

    const headers = [
      "Sr No",
      "Student Name",
      "Roll No",
      "Parent Name",
      "Parent Contact",
      "Exit Interview",
    ];

    const bodyData = withdrawalData.map((row, index) => [
      index + 1,
      row.studentName,
      row.rollNo,
      row.primeryContactName,
      row.primeryContact,
      row.isInterviewScheduled ? "Done" : "Not Scheduled",
    ]);

    doc.autoTable({
      head: [headers],
      body: bodyData,
      theme: "striped",
      startY: 30,
      headStyles: { fillColor: [132, 23, 26], textColor: [255, 255, 255] },
    });
    doc.save("WithdrawalProcess.pdf");
  };

  const filteredWithdrawalData = withdrawalData.filter((item) => {
    const searchLower = searchTerm.toLowerCase();
    const exitInterviewStatus = item.isInterviewScheduled
      ? "done"
      : "not scheduled";
    return (
      item.studentName.toLowerCase().includes(searchLower) ||
      item.rollNo.toLowerCase().includes(searchLower) ||
      item.primeryContactName.toLowerCase().includes(searchLower) ||
      item.primeryContact.toLowerCase().includes(searchLower) ||
      exitInterviewStatus.includes(searchLower)
    );
  });

  const canGeneratePayChallan = (row) => {
    return row.interviewScheduleDate;
  };

  const baseColumns = [
    {
      accessorKey: "mrt-row-numbers",
      header: "Sr No.",
      enableColumnOrdering: false,
      enableEditing: false, 
      enableSorting: false, 
      size: 80,
      Cell: ({ row }) => row.index + 1,
    },
    {
      accessorKey: "studentName",
      header: "Student",
      // width: 250,
      Cell: ({ row }) => {
        return (
          <>
            {row.original.studentName}
            <button
              type="button"
              className="btn p-0 ms-2 d-none"
              data-tooltip-id="global-tooltip"
              data-tooltip-content="Student Profile"
              onClick={(e) => {
                e.stopPropagation();
                setSelectedStudent(row.original);
                setIsProfileModalOpen(true);
              }}
            >
              <i className="text-primary fs-9 fas fa-user-gear"></i>
            </button>
          </>
        );
      },
    },
    {
      accessorKey: "rollNo",
      header: "Roll No",
      // width: 120,
    },
    {
      accessorKey: "primeryContactName",
      header: "Parent Name",
      // width: 150,
    },
    {
      accessorKey: "primeryContact",
      header: "Parent Contact",
      // width: 150,
    },
    {
      accessorKey: "submissionDate",
      header: "Withdrawal Status",
      size: 200,
      Cell: ({ row }) =>
        row.original.submissionDate ? (
          <span
            className="badge bg-success fs-10"
            data-tooltip-id="global-tooltip"
            data-tooltip-content={row.original.submissionDate.split("T")[0]}
          >
            Withdrawn
          </span>
        ) : (
          <span className="badge bg-warning fs-10">Pending</span>
        ),
    },
    {
      header: "Exit Interview",
      accessorKey: "isInterviewScheduled",
      // width: 200,
      Cell: ({ row }) => {
        const currentRoleId = String(roleId);
        const isScheduled = row.original.isInterviewScheduled || false;
        const interviewTime = new Date(
          row.original.interviewScheduleDate
        ).toLocaleTimeString([], {
          hour: "2-digit",
          minute: "2-digit",
          hour12: true,
        });

        if (isScheduled && row.original.interviewScheduleDate) {
          if (currentRoleId === "3") {
            return (
              <div className="text-center d-flex align-items-center gap-2">
                <span>
                  <i className="text-success fs-9 fas fa-check-circle" />
                  <span className="ms-1">
                    {row.original.interviewScheduleDate?.split("T")[0]} {interviewTime}
                  </span>
                </span>
                <button
                  type="button"
                  className="btn py-1 px-0"
                  data-tooltip-id="global-tooltip"
                  data-tooltip-content="Reschedule Interview"
                  onClick={() => handleExitInterview(row.original.id)}
                >
                  <i className="text-warning fs-9 fas fa-calendar-alt" />
                </button>
              </div>
            );
          } else {
            return (
              <span>
                <i className="text-success fs-9 fas fa-check-circle" />
                <span className="ms-1">
                  {row.original.interviewScheduleDate?.split("T")[0]} {interviewTime}
                </span>
              </span>
            );
          }
        } else if (currentRoleId === "3") {
          return (
            <div className="text-center d-flex gap-2">
              <button
                type="button"
                className="btn py-1 px-0"
                data-tooltip-id="global-tooltip"
                data-tooltip-content="Schedule Exit Interview"
                onClick={() => handleExitInterview(row.original.id)}
              >
                <i className="text-primary fs-9 fas fa-calendar-alt" />
              </button>
            </div>
          );
        } else {
          return (
            <div className="">
              <i className="fas fs-9 fa-exclamation-circle text-black-50" />
            </div>
          );
        }
      },
    },
  ];

  const activeDepartments = useMemo(() => {
    return departments.filter((dept) => {
      if (dept.id.toString() === "318" || dept.id.toString() === "314") {
        return false;
      }
      if (
        !["9", "10", "3"].includes(roleId) &&
        dept.id.toString() === departmentId
      ) {
        return withdrawalData.some((row) => row[`is${dept.key}`]);
      }
      if (["9", "10", "3"].includes(roleId)) {
        return withdrawalData.some((row) => row[`is${dept.key}`]);
      }
      return false;
    });
  }, [departments, withdrawalData, roleId, departmentId]);

  const getDepartmentColumns = () => {
    return activeDepartments.map((dept) => ({
      header: dept.value,
      accessorFn: (row) => row.studentName,
      // width: 100,
      Cell: ({ row }) => {
        const isApproved =
          row.original.departments?.[dept.id]?.approved || row.original[`is${dept.key}`] || false;
        const canApprove = dept.id.toString() === "314" || row.original.isApprovedByHead;

        if (["9", "10", "3"].includes(roleId)) {
          return (
            <div className="text-center">
              {isApproved ? (
                <i className="fas fa-check-circle fs-9 text-success" />
              ) : (
                <i className="fas fa-exclamation-circle text-black-50" />
              )}
            </div>
          );
        } else {
          return (
            <div className="text-center">
              {isApproved ? (
                <i
                  className="fas fa-check-circle fs-9 text-success"
                  data-tooltip-id="global-tooltip"
                  data-tooltip-content="Approved"
                />
              ) : (
                <button
                  type="button"
                  className="btn py-1 px-0"
                  data-tooltip-id="global-tooltip"
                  data-tooltip-content="Approve"
                  onClick={() =>
                    handleIssuedItemsButtonClick(row.original.studentId, dept.value)
                  }
                  disabled={!canApprove}
                >
                  <i
                    className={`fs-9 fas fa-circle-check ${
                      canApprove ? "text-primary" : "text-muted"
                    }`}
                  />
                </button>
              )}
            </div>
          );
        }
      },
    }));
  };

  const viewPaymentProof = (row) => {
    try {
      // // Find the student record from withdrawalData
      // const student = withdrawalData.find((s) => s.studentId === row.studentId);

      // if (!student || !student.invoiceProofPath) {
      //   toast.error("No payment proof found for this student");
      //   return;
      // }

      // Construct the full image URL using the invoiceProofPath
      const imageUrl = `${process.env.REACT_APP_LIVE_DOMAIN_URL}ExternalImages${row.invoiceProofPath}`;

      // Open the image in a new tab
      const newWindow = window.open(imageUrl, "_blank");
      if (!newWindow) {
        toast.error(
          "Pop-up blocked. Please allow pop-ups to view the payment proof."
        );
      }
    } catch (error) {
      console.error("Error viewing payment proof:", error);
      toast.error("Failed to view payment proof");
    }
  };

  const interviewRemarksColumn = {
    header: "Interview Remarks",
    accessorKey: "interviewRemarks",
    size: 200,
    Cell: ({ row }) => {
      const currentRoleId = String(roleId);
      if (currentRoleId === "30") {
        return (
          <div className="text-center">
            <button
              type="button"
              className="btn py-1 px-0"
              data-tooltip-id="global-tooltip"
              data-tooltip-content="Interview Remarks"
              onClick={() => handleInterviewRemarks(row.original.id)}
            >
              <i className="fas fa-comment fs-9 text-primary" />
            </button>
          </div>
        );
      } else if (
        [3, 7, 9, 10].includes(parseInt(roleId)) &&
        row.original.interviewScheduleDate
      ) {
        return (
          <div className="text-center">
            <button
              type="button"
              className="btn py-1 px-0"
              data-tooltip-id="global-tooltip"
              data-tooltip-content="Interview Remarks"
              onClick={() => handleInterviewRemarks(row.original.id)}
              // disabled={[3].includes(parseInt(roleId)) && !row.invoiceProofPath}
              // disabled={row.isApprovedByHead}
            >
              <i className="text-primary fs-9 fas fa-comment" />
            </button>
          </div>
        );
      } else {
        return null;
      }
    },
    // omit property is not directly supported in column definition for filtering in MRT often, 
    // but the columns hook filtering logic (lines 1435-1455) handles inclusion/exclusion.
    // However, if we want to conditionally hide, we can use `enableHiding` or filter it out in usage.
    // The original code used `omit` which was handled by react-data-table-component.
    // Here we rely on the `columns` useMemo logic to include/exclude it.
    // So distinct column definition object is fine.
  };

  const PERMISSIONS = {
    PARENT: {
      roleIds: ["9", "10"],
      actions: [
        {
          name: "printChallan",
          icon: "fas fa-print",
          handler: "handleGenerateChallan",
          tooltip: "Print Challan",
          visible: (row) => true,
          disabled: (row) =>
            !canGeneratePayChallan(row) ||
            !row.isApprovedByHead ||
            row.isAccountInvoiceChallanVerified === true ||
            uploadedProofs[row.id],
        },
        {
          name: "uploadPaymentProof",
          icon: "fas fa-image",
          handler: "handleUploadPaymentProofClick",
          tooltip: "Payment Proof",
          visible: (row) => true,
          disabled: (row) =>
            !canGeneratePayChallan(row) ||
            !row.isApprovedByHead ||
            row.isAccountInvoiceChallanVerified === true ||
            uploadedProofs[row.id],
        },
      ],
    },
    ADMIN: {
      roleIds: ["3"],
      actions: [
        {
          name: "printChallan",
          icon: "fas fa-print",
          handler: "handleGenerateChallan",
          tooltip: "Print Withdrawal Challan",
          visible: (row) => true,
          disabled: (row) =>
            !canGeneratePayChallan(row) || !row.isApprovedByHead,
        },
        {
          name: "paymentProof",
          icon: "fas fa-receipt",
          handler: "viewPaymentProof",
          tooltip: "Payment Proof",
          visible: (row) => row.invoiceProofPath,
          disabled: false,
        },
        {
          name: "payChallan",
          icon: "fas fa-file-invoice",
          handler: "handlePayChallan",
          tooltip: "Pay Challan",
          visible: (row) => !row.submissionDate,
          disabled: (row) => !row.isApprovedByHead || row.isPaid,
        },
        {
          name: "confirmWithdrawal",
          icon: "fas fa-check-double",
          handler: "handleWithdrawalConfirmation",
          tooltip: "Withdrawal Confirmation",
          visible: (row) => !row.submissionDate,
          disabled: (row) => !row.isPaid,
        },
        {
          name: "cancelWithdrawal",
          icon: "fas fa-times",
          handler: "handleOpenCancelModal",
          tooltip: "Cancel Withdrawal",
          visible: (row) => !row.submissionDate,
          disabled: () => false,
        },
        {
          name: "reAdmission",
          icon: "fas fa-redo-alt",
          handler: "handleReAdmission",
          tooltip: "Resubmission",
          visible: (row) => true,
          disabled: (row) => !row.isApprovedByHead,
        },
      ],
    },
  };

  const getActionsForRole = (roleId, departmentId) => {
    const roleConfig = Object.values(PERMISSIONS).find(
      (role) =>
        role.roleIds?.includes(String(roleId)) ||
        role.departmentIds?.includes(String(departmentId))
    );
    return roleConfig ? roleConfig.actions : [];
  };

  const actionColumn = {
    header: "Actions",
    // width: 120,
    Cell: ({ row }) => {
      const actions = getActionsForRole(roleId, departmentId);
      const handlers = {
        handleGenerateChallan,
        handlePayChallan,
        handleWithdrawalConfirmation,
        handleOpenCancelModal,
        handleUploadPaymentProofClick,
        handleVerifyPaymentProofClick,
        viewPaymentProof,
        handleReAdmission,
      };

      return (
        <div className="d-flex gap-2">
          {actions.map((action) => {
            if (action.visible && !action.visible(row.original)) {
              return null;
            }
            const isDisabled = action.disabled && action.disabled(row.original);

            return (
              <button
                key={action.name}
                type="button"
                className="btn p-0 border-0 custom-disabled-btn"
                data-tooltip-id="global-tooltip"
                data-tooltip-content={action.tooltip}
                onClick={() =>
                  handlers[action.handler](
                    action.name === "printChallan" ||
                      action.name === "payChallan" ||
                      action.name === "reAdmission"
                      ? row.original.studentId
                      : action.name === "cancelWithdrawal" ||
                        action.name === "verifyProof"
                      ? row.original.id
                      : row.original
                  )
                }
                disabled={isDisabled}
              >
                <i className={action.icon}></i>
              </button>
            );
          })}
        </div>
      );
    },
  };

  const columns = useMemo(() => {
    if (["7", "30"].includes(roleId)) {
      return [...baseColumns, interviewRemarksColumn];
    } else if (["9", "10", "3"].includes(roleId) || departmentId === "269") {
      return [
        ...baseColumns,
        interviewRemarksColumn,
        ...getDepartmentColumns(),
        actionColumn,
      ];
    } else {
      const userDepartment = departments.find(
        (d) => d.id.toString() === departmentId
      )?.value;
      return [
        ...baseColumns,
        interviewRemarksColumn,
        ...getDepartmentColumns().filter((col) => col.header === userDepartment),
      ];
    }
  }, [roleId, departmentId, departments, withdrawalData]);

  if (!departments.length) {
    return <div>Loading...</div>;
  }

  if (!departmentId) {
    return <div>Error: Department ID not set. Please contact support.</div>;
  }

  const handleBookReturnClick = async (row) => {
    try {
      const response = await get(
        `LMS/GetBookLoanByIDAsync?bookLoanId=${row.id}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      if (response.isSuccess) {
        setModalData(response?.bookLoanList);
        setShowModal(true);
      } else {
        console.error("Error fetching details");
      }
    } catch (error) {
      console.error("Error fetching", error);
    }
  };

  const submitBookReturn = async (formData) => {
    if (!token) {
      console.error("Unauthorized.");
      return;
    }

    try {
      const response = await post(
        `LMS/ReturnBookLoanUpdateByIDAsync`,
        formData,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (response.isSuccess) {
        toast.success(response.message || "Success!");
        setShowModal(false);
        setTriggerRender((prev) => !prev);
      }
    } catch (error) {
      console.error("Error saving book return:", error);
    }
  };

  return (
    <>
      <div className="page-header d-flex mb-2">
        <h2 className="page-heading mb-2 fs-7">Withdrawal Process</h2>
      </div>
      <div className="row g-3">
        <div className="col-md-12">
          <div className="card">
            <div className="card-body">
              <div className="d-flex align-items-center mb-3">
                <div style={{ width: "220px" }}>
                  <label className="form-label">Center</label>
                  <Controller
                    name="centerId"
                    control={control}
                    render={({ field }) => (
                      <Select
                        {...field}
                        options={centersData.map((center) => ({
                          value: center.id,
                          label: center.name,
                        }))}
                        isDisabled={
                          savedCenterId !== "0" && savedCenterId !== null
                        }
                        onChange={(selectedOption) => {
                          setValue("centerId", selectedOption);
                          setCenterId(
                            selectedOption ? selectedOption.value : null
                          );
                        }}
                        className="react-select-style"
                        classNamePrefix="react-select-style-pref"
                        placeholder="Select Center"
                      />
                    )}
                  />
                </div>
                {/* <div className="ms-auto">
                  <div className="d-flex align-items-center gap-1">
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Search"
                      value={searchTerm}
                      onChange={(e) => setSearchTerm(e.target.value)}
                    />
                    <button
                      type="button"
                      data-bs-toggle="tooltip"
                      data-bs-custom-class="custom-tooltip"
                      title="Export to Excel"
                      className="btn btn-outline-success px-2 py-1"
                      onClick={exportToExcel}
                    >
                      <i className="fs-8 fa fa-file-excel" />
                    </button>
                    <button
                      type="button"
                      data-bs-toggle="tooltip"
                      data-bs-custom-class="custom-tooltip"
                      title="Export to PDF"
                      className="btn btn-outline-danger px-2 py-1"
                      onClick={exportToPDF}
                    >
                      <i className="fs-8 fa fa-file-pdf" />
                    </button>
                  </div>
                </div> */}
              </div>
              <CustomDatatableGrid
                columns={columns}
                data={filteredWithdrawalData}
                onExportExcel={exportToExcel}
                onExportPDF={exportToPDF}
                enableSearching={false}
              />
            </div>
          </div>
        </div>
      </div>
      {isInterviewModalVisible && (
        <WithdrawalInterviewModal
          onClose={() => setIsInterviewModalVisible(false)}
          withdrawalId={selectedStudentId}
          refreshOnSubmitSuccess={getWithdrawalProcessList}
          studentFirstRegistrationId={
            selectedInterviewData?.studentFirstRegistrationId
          }
        />
      )}
      {isRemarksModalVisible && (
        <ExitInterviewRemarksModal
          onClose={() => setIsRemarksModalVisible(false)}
          firstRegistrationId={selectedStudentId}
          interviewData={selectedInterviewData}
          refreshOnSubmitSuccess={getWithdrawalProcessList}
        />
      )}
      {showCancelModal && (
        <CancelWithdrawalModal
          show={showCancelModal}
          onClose={() => setShowCancelModal(false)}
          onConfirm={handleCancelWithdrawal}
          withdrawalId={selectedWithdrawalId}
          refreshOnSubmitSuccess={getWithdrawalProcessList}
        />
      )}
      {isWithdrawalConfirmationModalVisible && (
        <WithdrawalConfirmationModal
          onClose={() => setIsWithdrawalConfirmationModalVisible(false)}
          studentId={selectedStudentId}
          withdrawalId={selectedStudentWithdrawalId}
          refreshOnSubmitSuccess={getWithdrawalProcessList}
        />
      )}
      {isPayChallanModalVisible && (
        <PayWithdrawalChallanModal
          title="Pay Withdrawal Challan"
          onClose={() => setIsPayChallanModalVisible(false)}
          payWithdrawalChallan={submitPayWithdrawalChallan}
          withdrawalModalData={selectedWithdrawalData}
        />
      )}
      {isPaymentProofModalVisible && (
        <PaymentProofModal
          title="Payment Proof"
          onClose={() => setIsPaymentProofModalVisible(false)}
          modalData={paymentProofModalData}
          submitData={submitPaymentProof}
        />
      )}
      {isVerifyPaymentModalOpen && (
        <AskConfirmationModal
          handleClose={() => setIsVerifyPaymentModalOpen(false)}
          handleConfirm={handleVerifyPaymentConfirm}
          isSubmitting={isSubmitting}
          message="Are you sure you want to verify this payment proof?"
        />
      )}
      {isIssuedItemsModalVisible && (
        <IssuedItemsModal
          title="Department Approval"
          onClose={() => setIsIssuedItemsModalVisible(false)}
          issuedItemsModalData={issuedItemsData}
          submitApprove={submitApproveClick}
          returnItem={handleBookReturnClick}
        />
      )}
      {showModal && (
        <BookModal
          title="Return Book"
          onClose={() => setShowModal(false)}
          data={modalData}
          returnBook={submitBookReturn}
        />
      )}
      {isProfileModalOpen && (
        <StudentProfile
          student={selectedStudent}
          onClose={() => setIsProfileModalOpen(false)}
        />
      )}
      {isReAdmissionModalVisible && (
        <ReAdmissionModal
          onClose={() => setIsReAdmissionModalVisible(false)}
          studentId={selectedStudentForReAdmission}
          refreshOnSubmitSuccess={() => getWithdrawalProcessList()}
        />
      )}
      {loading && <FullScreenLoader />}
    </>
  );
}

export default WithdrawalProcess;
